module.exports = __webpack_public_path__ + "img/p7-p2-text.f54ef9dd.png";